import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieGridProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  viewAllLink?: string;
}

export default function MovieGrid({ title, subtitle, movies, viewAllLink }: MovieGridProps) {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-end justify-between mb-5 md:mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>
          )}
        </div>
        {viewAllLink && (
          <Link
            to={viewAllLink}
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4" data-product-shop>
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}